/**
 * Global session-expiration handling, ported from `bluehomerwebappservice`.
 *
 * Any BFF call can 401 once the session expires or is cleared server-side. Without one place to
 * handle it, each page shows its own raw error — or worse, retries a dead session in a loop — and
 * the user is left on a screen that will never load again.
 */

const PUBLIC_PATHS = new Set(['/login'])

let redirecting = false

/**
 * Call when any `/api` response comes back 401.
 *
 * No-ops on the login page, which would otherwise reload itself. Guards against re-entry too: a
 * screen that fires six parallel requests produces six 401s, and six `location.assign` calls race
 * to reload a page that is already leaving.
 */
export function redirectToLoginOnSessionExpired(): void {
  if (typeof window === 'undefined') return
  if (PUBLIC_PATHS.has(window.location.pathname)) return
  if (redirecting) return
  redirecting = true
  //  `assign`, not `replace`: the user should be able to go back to where they were after signing
  //  in again, and a full document load guarantees no stale React state survives the transition.
  window.location.assign('/login?session_expired=1')
}

/** Test seam — resets the one-shot latch between cases. */
export function __resetSessionGuardForTests(): void {
  redirecting = false
}
